/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect, useRef} from "react";
// reactstrap components
import NotificationAlert from "react-notification-alert";
import { Tabs, Tab } from "react-bootstrap";
import {  
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col  
} from "reactstrap";
import { useHistory } from 'react-router-dom';
import del from "assets/img/del.png";

import PlayerProfile from './PlayerProfile';
import Analysis1 from './Analysis1';
import BigGoalsetting from './BigGoalsetting';
import GoalSetting from './GoalSetting';
import Preparation from './Preparation';
import Tables from './Tables';
import Diary from './Diary';

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";

let session = {};
let notificationAlert;
let imgFile = "";

function Son() {

  notificationAlert = React.useRef(); 
  const history = useHistory();
  const [selectKey, setSelectKey] = useState(window.sessionStorage.getItem('selectKey') || 'profile');
    
  session = JSON.parse(window.sessionStorage.getItem('player')); 

  useEffect(() => {
    
    if(session === null){      
      window.location = '/';
    }  

  }, []);

  const tobackPage = (e) => {
    history.push('../parent/userMg');
  }

  const onTabSelect = (eventKey) => {
    // console.log(eventKey);
    window.sessionStorage.setItem('selectKey', eventKey);
    setSelectKey(eventKey);
  }

  return (

    <>
      <div className="content px-0 pb-0" style={{background:'white'}}>
        <NotificationAlert ref={notificationAlert} />
        <div className="selected_player">
          <Row className="py-2 px-0 mx-0" onClick={(e) => tobackPage(e)}>
            <div className="text-center col-2 px-0">
              <img className="s_player_icon" src={(session.profile_photo_path ? "https://xs458763.xsrv.jp/uploads/"+session.profile_photo_path : require("assets/img/mike.png").default)}/>
            </div>
            <div className="d-flex align-items-center col-10 px-0">
              <span style={{width:'100%', whiteSpace:'pre-wrap'}}>{session.name}</span>
            </div>  
          </Row>
        </div>
        <Row className="px-0 mx-0 coach-aph">
          <Col md="12" className="colp playerInfoTab">
            <Tabs fill activeKey={selectKey} defaultActiveKey="profile" id="uncontrolled-tab-example" onSelect={(k) => onTabSelect(k)}>
              <Tab
                eventKey="profile"
                title="プロフィール"
                mountOnEnter // <<<
                unmountOnExit={false} // <<<
              >
                <PlayerProfile />
              </Tab>
              <Tab
                eventKey="analysis"
                title="自己分析"
                mountOnEnter // <<<
                unmountOnExit={false} // <<<
              >
                <Analysis1 />
              </Tab>
              <Tab
                eventKey="biggoalsetting"
                title="大会目標"
                mountOnEnter // <<<
                unmountOnExit={false} // <<<
              >
                <BigGoalsetting />
              </Tab>
              <Tab
                eventKey="goalsetting"
                title="課題目標"
                mountOnEnter // <<<
                unmountOnExit={false} // <<<
              >
                <GoalSetting />
              </Tab>
              <Tab
                eventKey="diary"
                title="日記"
                mountOnEnter // <<<
                unmountOnExit={false} // <<<
              >
                <Diary />
              </Tab>
              <Tab
                eventKey="preparation"
                title="試合準備"
                mountOnEnter // <<<
                unmountOnExit={false} // <<<
              >
                <Preparation />
              </Tab>
              <Tab
                eventKey="table"
                title="試合後リフレクション"
                mountOnEnter // <<<
                unmountOnExit={false} // <<<
              >
                <Tables />
              </Tab>
            </Tabs>   
          </Col>
          <Col md="12" className="colp">
            <div className="col-12">
              <input type="button" name="user" value="戻る" className="btn-round btn btn-primary" onClick={tobackPage}/>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
export default Son;
